var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoanIco(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0.944336V4.96051C11 5.2268 11.1054 5.48218 11.2929 5.67047C11.4804 5.85877 11.7348 5.96455 12 5.96455H16",
    stroke: "#573A7A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 15.0009H7C6.46957 15.0009 5.96086 14.7894 5.58579 14.4128C5.21071 14.0362 5 13.5254 5 12.9929V2.95242C5 2.41984 5.21071 1.90908 5.58579 1.53249C5.96086 1.1559 6.46957 0.944336 7 0.944336H11L16 5.96455V12.9929C16 13.5254 15.7893 14.0362 15.4142 14.4128C15.0391 14.7894 14.5304 15.0009 14 15.0009Z",
    stroke: "#573A7A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.0014V17.0095C12 17.542 11.7893 18.0528 11.4142 18.4294C11.0391 18.806 10.5304 19.0175 10 19.0175H3C2.46957 19.0175 1.96086 18.806 1.58579 18.4294C1.21071 18.0528 1 17.542 1 17.0095V6.96902C1 6.43645 1.21071 5.92568 1.58579 5.54909C1.96086 5.1725 2.46957 4.96094 3 4.96094H5",
    stroke: "#573A7A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoanIco);
export default __webpack_public_path__ + "static/media/loanIco.3ab3bf53f49b0440b54ff7124749dce6.svg";
export { ForwardRef as ReactComponent };